/* Vannucci : petite animation quand un produit est VRAIMENT ajouté au panier.
   Écoute « vcu:done » (assets/vannucci-cart-upsell.js, detail.ok = true) : la vignette du produit
   s'envole en arc jusqu'à l'icône panier de l'en-tête (ou jusqu'au compteur du panier latéral s'il est ouvert),
   puis l'icône fait un petit rebond. Purement décoratif : rien ne dépend de l'animation.
   Désactivée si l'appareil demande moins d'animations. */
(() => {
  const reduit = window.matchMedia('(prefers-reduced-motion: reduce)');

  function visible(el) {
    if (!el) return false;
    const r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < window.innerHeight;
  }

  function cible() {
    const tiroir = document.querySelector('#cart-drawer dialog[open]');
    if (tiroir) {
      // la pastille du nombre d'articles en priorité, sinon le titre « Votre panier »
      const badge = tiroir.querySelector('.theme-drawer__badge');
      if (visible(badge)) return badge;
      const titre = tiroir.querySelector('.theme-drawer__title');
      if (visible(titre)) return titre;
    }
    const icones = Array.from(document.querySelectorAll('cart-icon'));
    return icones.find(visible) || null;
  }

  function vignette(bouton) {
    const carte = bouton.closest('article, li, .vtr__carte, .vtc, [data-vfp], .vfp, section, .product-information');
    const img = carte && carte.querySelector('img');
    if (img && img.currentSrc) return img.currentSrc;
    const principale = document.querySelector('.vfg img, .product-media img');
    return principale && principale.currentSrc ? principale.currentSrc : '';
  }

  function rebond(el) {
    if (!el) return;
    el.classList.remove('vaa-rebond');
    void el.offsetWidth;
    el.classList.add('vaa-rebond');
    setTimeout(() => el.classList.remove('vaa-rebond'), 700);
  }

  function envol(bouton) {
    const arrivee = cible();
    const depart = bouton.getBoundingClientRect();
    if (!arrivee || !depart.width) {
      rebond(arrivee);
      return;
    }
    const fin = arrivee.getBoundingClientRect();
    const taille = 56;
    const x0 = depart.left + depart.width / 2 - taille / 2;
    const y0 = depart.top + depart.height / 2 - taille / 2;
    const dx = fin.left + fin.width / 2 - taille / 2 - x0;
    const dy = fin.top + fin.height / 2 - taille / 2 - y0;

    const bulle = document.createElement('span');
    bulle.className = 'vaa-bulle';
    bulle.setAttribute('aria-hidden', 'true');
    bulle.style.left = x0 + 'px';
    bulle.style.top = y0 + 'px';
    const src = vignette(bouton);
    if (src) {
      const i = document.createElement('img');
      i.src = src;
      i.alt = '';
      bulle.appendChild(i);
    } else {
      bulle.classList.add('vaa-bulle--vide');
    }
    document.body.appendChild(bulle);

    const haut = Math.min(-60, dy / 2 - 90);
    const anim = bulle.animate(
      [
        { transform: 'translate(0, 0) scale(0.6)', opacity: 0 },
        { transform: 'translate(0, -14px) scale(1.05)', opacity: 1, offset: 0.18 },
        { transform: `translate(${dx * 0.55}px, ${haut}px) scale(0.75)`, opacity: 1, offset: 0.6 },
        { transform: `translate(${dx}px, ${dy}px) scale(0.22)`, opacity: 0.4 },
      ],
      { duration: 820, easing: 'cubic-bezier(0.45, 0, 0.25, 1)', fill: 'forwards' }
    );
    anim.onfinish = () => {
      bulle.remove();
      rebond(arrivee.closest('cart-icon') || arrivee);
    };
    anim.oncancel = () => bulle.remove();
  }

  document.addEventListener('vcu:done', (event) => {
    if (reduit.matches || !event.detail || !event.detail.ok) return;
    const bouton = event.target;
    if (!(bouton instanceof HTMLElement) || !bouton.isConnected) {
      rebond(cible());
      return;
    }
    envol(bouton);
  });
})();
